import CompanyPage from '../components/CompanyPage';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Company | Cartwheel',
  'Meet Cartwheel, the lab building kinetic world models and datasets that make physical AI training tractable at scale.',
);

export default CompanyPage;
